// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__h1Y7M","main-content":"Layout_main-content__oZzC2","nav-hide":"Layout_nav-hide__B2lzl"};